// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/7c8618543cc544bea220.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"a57319f3c055b76091a9","180":"8ba504c0c9a43b6df478","245":"f1163f2aee69ef31dde3","246":"d85a0fe3e5c29a587600","247":"e6a0de8df40aa02581eb"}[chunkId] + ".chunk.js";
};